import PurchaseHistoryCard from './PurchaseHistoryCard';
import { PurchaseHistoryProps } from './types';
export default PurchaseHistoryCard;
export type { PurchaseHistoryProps };
